export default __webpack_public_path__ + "static/media/005-Science fiction.cf75f1a3.svg";